import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Markdown from 'react-markdown';
import { TwemojiWrapper } from './twemojiWrapper';
const MARKDOWN_CONTAINER_CSS = css `
  > p {
    margin: 0;
  }
  ul {
    margin: 0;
  }
`;
export const MarkdownRenderer = ({ markdown }) => {
    return (_jsx(TwemojiWrapper, { children: _jsx(Markdown, { css: MARKDOWN_CONTAINER_CSS, children: markdown }) }));
};
